var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlaggedContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_820_911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.666 8.90015C22.7579 8.90015 22.833 8.97528 22.833 9.06714V22.5671H22.499V9.23315H11.166V8.90015H22.666Z",
    fill: "#F56565",
    stroke: "#F56565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 11.5669H19.999C20.0909 11.5669 20.166 11.642 20.166 11.7339V23.7339C20.1658 23.8256 20.0908 23.8999 19.999 23.8999H9.33301C9.24126 23.8999 9.16619 23.8256 9.16602 23.7339V11.7339C9.16602 11.642 9.24115 11.5669 9.33301 11.5669ZM10.833 21.5669H15.833V19.2339H10.833V21.5669ZM10.833 18.8999H18.499V16.5669H10.833V18.8999ZM10.833 16.2339H18.499V13.8999H10.833V16.2339Z",
    fill: "#F56565",
    stroke: "#F56565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8.40015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaggedContentIcon);
export default __webpack_public_path__ + "static/media/flagged-content-icon.7f031326a6045dcc80eeacef73664f71.svg";
export { ForwardRef as ReactComponent };